import { useTranslation } from 'next-i18next'

import { CategoryColorClasses } from '~/bootcamp/constants/bootcamp.const'

export default function ActivitiesHeader({
  isQuizPage,
  subjectName,
  isSplashScreen,
  title,
  colorInfo,
}: {
  isQuizPage: boolean
  subjectName: string
  isSplashScreen?: boolean
  title: string
  colorInfo: CategoryColorClasses
}): React.ReactElement {
  const { t } = useTranslation('bootcampQuiz')

  return (
    <header className={`flex items-center mb-3 ${isSplashScreen && 'pr-10'}`}>
      <hgroup className={`${isSplashScreen ? 'text-white' : 'text-black-light'} ml-2 flex-1`}>
        <h2 className="tracking-wider">{subjectName}</h2>
        <h1
          className={`font-bold text-md lg:text-h3 leading-6 lg:leading-8 tracking-wide ${
            isSplashScreen ? 'text-white' : colorInfo.textClass
          }`}
        >
          {isQuizPage ? t('quizPage') : title}
        </h1>
      </hgroup>
    </header>
  )
}
